<script lang="ts" setup>
import { sendGtagEvent } from '@/helpers/analitics';

import ImgError from '@/assets/images/warning-24-red.svg';
import ImgSuccess from '@/assets/images/check-circle-24.svg';
import ImgWarning from '@/assets/images/warning-24-orange.svg';
import ImgInfo from '@/assets/images/question-circle-24.svg';

const props = defineProps<{
  data: InfoBanner;
}>();

const emit = defineEmits<{
  change: [value: boolean];
}>();

const closeBanner = function closeBanner() {
  emit('change', false);
};

const iconMap: Record<InfoBanner['type'], string> = {
  error: ImgError,
  warning: ImgWarning,
  success: ImgSuccess,
  info: ImgInfo,
};

onMounted(() => {
  const label = `${props.data.type}: ${props.data.message}`.replaceAll(
    ' ',
    '-',
  );

  sendGtagEvent('Vue-alert-show', {
    event_category: 'Site',
    event_label: label,
  });
});
</script>

<template>
  <div
    class="info-banner"
    :class="`info-banner--${props.data.type}`"
  >
    <div class="info-banner__header">
      <img
        class="info-banner__icon"
        :src="iconMap[props.data.type]"
        alt="info"
        width="24"
        height="24"
      />

      <p class="info-banner__title text-h5">
        {{ props.data.title ?? '' }}
      </p>

      <button
        class="info-banner__close"
        type="button"
        @click="closeBanner"
      >
        <svg
          aria-hidden="true"
          width="16"
          height="16"
        >
          <use
            xlink:href="@/assets/images/svg/sprite-base.svg#x-close-cross-16"
          ></use>
        </svg>
      </button>
    </div>

    <div
      class="info-banner__description text-body-sc"
      v-html="props.data.message"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
.info-banner {
  $this: 'info-banner';

  position: fixed;
  bottom: 24px;
  right: 16px;
  left: 16px;
  z-index: 3001;
  background-color: $color-secondary-100;
  border: 1px solid $color-secondary-400;
  border-radius: $brd-16;
  padding: 18px 16px;
  box-shadow: 0 4px 24px 0 #222e3a1f;

  @include media('sm') {
    left: auto;
    width: 550px;
  }

  @include media('md') {
    right: 24px;
  }

  &--success {
    background-color: $color-green-100;
    border-color: $color-green-400;
  }

  &--error {
    background-color: $color-red-100;
    border-color: $color-red-300;
  }

  &--warning {
    background-color: $color-yellow-100;
    border-color: $color-yellow-400;
  }

  &__header {
    display: flex;
    align-items: flex-start;
    column-gap: 8px;
    margin-bottom: 8px;
  }

  &__icon {
    flex-shrink: 0;
    transform: translateY(3px);
  }

  &__title {
    flex-grow: 1;
  }

  &__close {
    @include reset-btn;

    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-black-500;
    flex-shrink: 0;
    transform: translateY(3px);
  }
}
</style>
